// Reconstructed from the supplied production build; original component names were unavailable.
import { useAdminAuth } from "../context/AdminAuthContext.jsx";
import {
  ActivityIcon,
  AnimatePresence,
  CalendarIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  DollarSignIcon,
  EyeIcon,
  MailIcon,
  PenLineIcon,
  PhoneIcon,
  React,
  RefreshCwIcon,
  SaveIcon,
  SearchIcon,
  ShoppingBagIcon,
  Trash2Icon,
  TrendingUpIcon,
  TriangleAlertIcon,
  UserPlusIcon,
  UsersIcon,
  XIcon,
  jsxRuntime,
  motion,
  useNavigate,
} from "../vendor/runtime.js";
import { api } from "../services/api.js";
const UsersPage = () => {
  const { adminUser: e } = useAdminAuth(),
    t = useNavigate(),
    [n, r] = React.useState([]),
    [a, l] = React.useState(true),
    [c, d] = React.useState(null),
    [f, h] = React.useState(""),
    [p, g] = React.useState("all"),
    [y, v] = React.useState({}),
    [j, N] = React.useState({}),
    [b, S] = React.useState(false),
    [O, _] = React.useState(false),
    [C, A] = React.useState(false),
    [T, M] = React.useState(false),
    [k, $] = React.useState(false),
    [I, U] = React.useState(false),
    [q, z] = React.useState(null),
    [Y, F] = React.useState(null),
    [B, K] = React.useState(null),
    [Q, ne] = React.useState(null),
    [L, ee] = React.useState(null),
    [re, R] = React.useState([]),
    [W, xe] = React.useState(false),
    [ve, te] = React.useState(false),
    [ye, V] = React.useState({
      name: "",
      email: "",
      phone: "",
      active_status: "active",
    }),
    [de, oe] = React.useState({
      id: "",
      product_id: "",
      product_title: "",
      status: "completed",
      razorpay_order_id: "",
      razorpay_payment_id: "",
      purchase_date: "",
      amount: "",
    }),
    [ce, $e] = React.useState(false),
    [Ae, st] = React.useState(false),
    [Ve, tt] = React.useState(false),
    [_n, Bn] = React.useState(false),
    [Xe, $t] = React.useState(1),
    [on] = React.useState(10),
    On = {
      hidden: {
        opacity: 0,
        y: 20,
      },
      visible: {
        opacity: 1,
        y: 0,
        transition: {
          duration: 0.4,
        },
      },
    },
    ia = {
      hidden: {
        opacity: 0,
      },
      visible: {
        opacity: 1,
        transition: {
          staggerChildren: 0.1,
        },
      },
    },
    Oa = async (Z) => {
      var Le;
      if (!(!Z || Z === ""))
        try {
          te(true);
          const Ie = (await api.get(`/admin/products/${Z}`)).data;
          Ie &&
            Ie.title &&
            oe((Pt) => ({
              ...Pt,
              product_title: Ie.title,
            }));
        } catch (Ne) {
          (console.error("Error fetching product details:", Ne),
            ((Le = Ne.response) == null ? undefined : Le.status) === 404 &&
              (oe((Ie) => ({
                ...Ie,
                product_title: "",
              })),
              alert("Product not found with this ID")));
        } finally {
          te(false);
        }
    };
  React.useEffect(() => {
    if (k && de.product_id && de.product_id !== (Q == null ? undefined : Q.product_id)) {
      const Z = setTimeout(() => {
        Oa(de.product_id);
      }, 500);
      return () => clearTimeout(Z);
    }
  }, [de.product_id, k]);
  const Ur = async (Z) => {
      try {
        const Ne = (await api.get(`/admin/users/${Z}/purchases`)).data || [];
        v((_t) => ({
          ..._t,
          [Z]: Ne,
        }));
        const Ie = Ne.length,
          Pt = Ne.reduce((_t, qn) => {
            const Jt = parseFloat(qn.amount || 0);
            return _t + Jt;
          }, 0);
        return (
          N((_t) => ({
            ..._t,
            [Z]: {
              purchaseCount: Ie,
              totalAmount: Pt,
            },
          })),
          {
            purchases: Ne,
            purchaseCount: Ie,
            totalAmount: Pt,
          }
        );
      } catch (Le) {
        return (
          console.error(`Error fetching purchases for user ${Z}:`, Le),
          v((Ne) => ({
            ...Ne,
            [Z]: [],
          })),
          N((Ne) => ({
            ...Ne,
            [Z]: {
              purchaseCount: 0,
              totalAmount: 0,
            },
          })),
          {
            purchases: [],
            purchaseCount: 0,
            totalAmount: 0,
          }
        );
      }
    },
    gn = async (Z) => {
      S(true);
      try {
        const Ne = [];
        for (let Ie = 0; Ie < Z.length; Ie += 5) Ne.push(Z.slice(Ie, Ie + 5));
        for (const Ie of Ne) {
          const Pt = Ie.map((_t) => Ur(_t.id));
          (await Promise.all(Pt),
            Ne.indexOf(Ie) < Ne.length - 1 && (await new Promise((_t) => setTimeout(_t, 200))));
        }
      } catch (Le) {
        console.error("Error loading user stats:", Le);
      } finally {
        S(false);
      }
    },
    bt = (Z) =>
      j[Z] || {
        purchaseCount: 0,
        totalAmount: 0,
      };
  React.useEffect(() => {
    Lt();
  }, []);
  const Lt = async () => {
      try {
        (l(true), d(null));
        const Le = (await api.get("/admin/users")).data || [];
        (r(Le), Le.length > 0 && (await gn(Le)));
      } catch (Z) {
        (console.error("Error fetching users:", Z), d("Failed to load users. Please try again."));
      } finally {
        l(false);
      }
    },
    me = async (Z) => {
      try {
        if ((xe(true), y[Z])) {
          (R(y[Z]), xe(false));
          return;
        }
        const { purchases: Le } = await Ur(Z);
        R(Le);
      } catch (Le) {
        (console.error("Error fetching user purchases:", Le), R([]));
      } finally {
        xe(false);
      }
    },
    Ue = async (Z) => {
      (z(Z), _(true), await me(Z.id));
    },
    ot = (Z) => {
      (F(Z),
        V({
          name: Z.name || "",
          email: Z.email || "",
          phone: Z.phone ? Z.phone.toString() : "",
          active_status: Z.active_status || "active",
        }),
        A(true));
    },
    rt = async (Z) => {
      var Ne, Ie, Pt, _t, qn, Jt, Yn, gt;
      if ((Z.preventDefault(), !ye.name.trim())) {
        alert("Name is required");
        return;
      }
      if (!ye.email.trim()) {
        alert("Email is required");
        return;
      }
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(ye.email.trim())) {
        alert("Please enter a valid email address");
        return;
      }
      if (ye.phone && ye.phone.toString().trim()) {
        const We = ye.phone.toString().trim();
        if (!/^\d{10,}$/.test(We)) {
          alert("Please enter a valid phone number (minimum 10 digits)");
          return;
        }
      }
      try {
        $e(true);
        const We = {
          name: ye.name.trim(),
          email: ye.email.trim().toLowerCase(),
          phone: ye.phone ? parseInt(ye.phone.toString().replace(/\D/g, "")) : null,
          active_status: ye.active_status,
        };
        We.phone || delete We.phone;
        const yt = (await api.put(`/admin/users/${Y.id}`, We)).data || {
          ...Y,
          ...We,
        };
        (r(
          n.map((Un) =>
            Un.id === Y.id
              ? {
                  ...Un,
                  ...yt,
                }
              : Un,
          ),
        ),
          q &&
            q.id === Y.id &&
            z({
              ...q,
              ...yt,
            }),
          A(false),
          F(null),
          V({
            name: "",
            email: "",
            phone: "",
            active_status: "active",
          }),
          alert("User updated successfully!"));
      } catch (We) {
        console.error("Error updating user:", We);
        let Gt = "Failed to update user";
        ((Ie = (Ne = We.response) == null ? undefined : Ne.data) != null && Ie.error
          ? (Gt = We.response.data.error)
          : (_t = (Pt = We.response) == null ? undefined : Pt.data) != null && _t.message
            ? (Gt = We.response.data.message)
            : We.message && (Gt = We.message),
          ((qn = We.response) == null ? undefined : qn.status) === 400
            ? (Gt = "Invalid data provided. Please check your inputs.")
            : ((Jt = We.response) == null ? undefined : Jt.status) === 404
              ? (Gt = "User not found.")
              : ((Yn = We.response) == null ? undefined : Yn.status) === 409
                ? (Gt = "Email already exists for another user.")
                : ((gt = We.response) == null ? undefined : gt.status) === 422 &&
                  (Gt = "Validation failed. Please check your inputs."),
          alert(Gt));
      } finally {
        $e(false);
      }
    },
    wt = (Z) => {
      (K(Z), M(true));
    },
    Zt = async () => {
      var Z, Le;
      try {
        (tt(true),
          await api.delete(`/admin/users/${B.id}`),
          r(n.filter((Ne) => Ne.id !== B.id)),
          v((Ne) => {
            const Ie = {
              ...Ne,
            };
            return (delete Ie[B.id], Ie);
          }),
          N((Ne) => {
            const Ie = {
              ...Ne,
            };
            return (delete Ie[B.id], Ie);
          }),
          q && q.id === B.id && (_(false), z(null)),
          M(false),
          K(null));
      } catch (Ne) {
        (console.error("Error deleting user:", Ne),
          alert(
            ((Le = (Z = Ne.response) == null ? undefined : Z.data) == null
              ? undefined
              : Le.error) || "Failed to delete user",
          ));
      } finally {
        tt(false);
      }
    },
    pi = (Z) => {
      (ne(Z),
        oe({
          id: Z.id || "",
          product_id: Z.product_id || "",
          product_title: Z.product_title || "",
          status: Z.status || "completed",
          razorpay_order_id: Z.razorpay_order_id || "",
          razorpay_payment_id: Z.razorpay_payment_id || "",
          purchase_date: Z.purchase_date ? Z.purchase_date.split("T")[0] : "",
          amount: Z.amount || "",
        }),
        $(true));
    },
    sa = async (Z) => {
      var Le, Ne, Ie, Pt, _t, qn, Jt, Yn;
      if ((Z.preventDefault(), !de.product_title.trim())) {
        alert("Product title is required");
        return;
      }
      if (!de.product_id) {
        alert("Product ID is required");
        return;
      }
      if (!de.amount || parseFloat(de.amount) <= 0) {
        alert("Valid amount is required");
        return;
      }
      try {
        st(true);
        const gt = {
          product_id: parseInt(de.product_id),
          product_title: de.product_title.trim(),
          status: de.status,
          razorpay_order_id: de.razorpay_order_id.trim() || null,
          razorpay_payment_id: de.razorpay_payment_id.trim() || null,
          purchase_date: de.purchase_date ? new Date(de.purchase_date).toISOString() : null,
          amount: parseFloat(de.amount),
        };
        Object.keys(gt).forEach((Un) => {
          (gt[Un] === null || gt[Un] === "") && delete gt[Un];
        });
        const We = await api.put(`/admin/purchases/${Q.id}`, gt),
          Gt = {
            ...Q,
            ...gt,
            ...(We.data || {}),
          };
        R((Un) => Un.map((ns) => (ns.id === Q.id ? Gt : ns)));
        const yt = Q.user_id || (q == null ? undefined : q.id);
        if (yt) {
          v((Tn) => {
            var to;
            return {
              ...Tn,
              [yt]:
                ((to = Tn[yt]) == null ? undefined : to.map((Zl) => (Zl.id === Q.id ? Gt : Zl))) ||
                [],
            };
          });
          const Un =
              ((Le = y[yt]) == null ? undefined : Le.map((Tn) => (Tn.id === Q.id ? Gt : Tn))) || [],
            ns = Un.length,
            Ca = Un.reduce((Tn, to) => Tn + parseFloat(to.amount || 0), 0);
          N((Tn) => ({
            ...Tn,
            [yt]: {
              purchaseCount: ns,
              totalAmount: Ca,
            },
          }));
        }
        ($(false),
          ne(null),
          oe({
            id: "",
            product_id: "",
            product_title: "",
            status: "completed",
            razorpay_order_id: "",
            razorpay_payment_id: "",
            purchase_date: "",
            amount: "",
          }),
          alert("Purchase updated successfully!"));
      } catch (gt) {
        console.error("Error updating purchase:", gt);
        let We = "Failed to update purchase";
        ((Ie = (Ne = gt.response) == null ? undefined : Ne.data) != null && Ie.error
          ? (We = gt.response.data.error)
          : (_t = (Pt = gt.response) == null ? undefined : Pt.data) != null && _t.message
            ? (We = gt.response.data.message)
            : gt.message && (We = gt.message),
          ((qn = gt.response) == null ? undefined : qn.status) === 400
            ? (We = "Invalid data provided. Please check your inputs.")
            : ((Jt = gt.response) == null ? undefined : Jt.status) === 404
              ? (We = "Purchase not found.")
              : ((Yn = gt.response) == null ? undefined : Yn.status) === 422 &&
                (We = "Validation failed. Please check your inputs."),
          alert(We));
      } finally {
        st(false);
      }
    },
    Ta = (Z) => {
      (ee(Z), U(true));
    },
    ts = async () => {
      var Z, Le, Ne;
      try {
        (Bn(true),
          await api.delete(`/admin/purchases/${L.id}`),
          R((Pt) => Pt.filter((_t) => _t.id !== L.id)));
        const Ie = L.user_id || (q == null ? undefined : q.id);
        if (Ie) {
          const Pt = ((Z = y[Ie]) == null ? undefined : Z.filter((Jt) => Jt.id !== L.id)) || [];
          v((Jt) => ({
            ...Jt,
            [Ie]: Pt,
          }));
          const _t = Pt.length,
            qn = Pt.reduce((Jt, Yn) => Jt + parseFloat(Yn.amount || 0), 0);
          N((Jt) => ({
            ...Jt,
            [Ie]: {
              purchaseCount: _t,
              totalAmount: qn,
            },
          }));
        }
        (U(false), ee(null), alert("Purchase deleted successfully!"));
      } catch (Ie) {
        (console.error("Error deleting purchase:", Ie),
          alert(
            ((Ne = (Le = Ie.response) == null ? undefined : Le.data) == null
              ? undefined
              : Ne.error) || "Failed to delete purchase",
          ));
      } finally {
        Bn(false);
      }
    },
    Ea = n.filter((Z) => {
      var Ie, Pt, _t;
      const Le =
          ((Ie = Z.name) == null ? undefined : Ie.toLowerCase().includes(f.toLowerCase())) ||
          ((Pt = Z.email) == null ? undefined : Pt.toLowerCase().includes(f.toLowerCase())) ||
          ((_t = Z.phone) == null ? undefined : _t.includes(f)),
        Ne = p === "all" || Z.active_status === p || (p === "active" && !Z.active_status);
      return Le && Ne;
    }),
    Qt = Math.ceil(Ea.length / on),
    oa = (Xe - 1) * on,
    Cd = Ea.slice(oa, oa + on),
    Pd = () => {
      Xe < Qt && $t(Xe + 1);
    },
    Md = () => {
      Xe > 1 && $t(Xe - 1);
    },
    Yl = (Z) => {
      Z >= 1 && Z <= Qt && $t(Z);
    },
    Xl = () => {
      const Z = [];
      if (Qt <= 5) for (let Ne = 1; Ne <= Qt; Ne++) Z.push(Ne);
      else if (Xe <= 3) {
        for (let Ne = 1; Ne <= 3; Ne++) Z.push(Ne);
        Qt > 4 && (Z.push("..."), Z.push(Qt));
      } else if (Xe >= Qt - 2) {
        (Z.push(1), Qt > 4 && Z.push("..."));
        for (let Ne = Qt - 2; Ne <= Qt; Ne++) Z.push(Ne);
      } else {
        (Z.push(1), Z.push("..."));
        for (let Ne = Xe - 1; Ne <= Xe + 1; Ne++) Z.push(Ne);
        (Z.push("..."), Z.push(Qt));
      }
      return Z;
    },
    Wl = n.length,
    _p = n.filter((Z) => Z.active_status === "active" || !Z.active_status).length,
    la = n.filter((Z) => bt(Z.id).purchaseCount > 0).length,
    ln = n.reduce((Z, Le) => Z + bt(Le.id).totalAmount, 0);
  return (
    React.useEffect(() => {
      $t(1);
    }, [f, p]),
    a ? (
      <div className={"admin-page bg-gradient-to-br from-slate-50 to-purple-100"}>
          <div className={"flex items-center justify-center admin-page"}>
          <motion.div
            initial={{
              opacity: 0,
              scale: 0.8,
            }}
            animate={{
              opacity: 1,
              scale: 1,
            }}
            className={"text-center"}
          >
            <div className={"w-16 h-16 relative mx-auto mb-4"}>
              <div className={"absolute inset-0 rounded-full border-4 border-purple-300"} />
              <div
                className={"absolute inset-0 rounded-full border-t-4 border-purple-800 animate-spin"}
              />
            </div>
            <p className={"text-gray-600 font-medium"}>{"Loading users..."}</p>
            {b && (
              <p className={"text-gray-500 text-sm mt-2"}>{"Calculating purchase statistics..."}</p>
            )}
          </motion.div>
        </div>
      </div>
    ) : c ? (
      <div className={"admin-page bg-gradient-to-br from-slate-50 to-purple-100"}>
          <div className={"flex items-center justify-center admin-page p-4"}>
          <motion.div
            initial={{
              opacity: 0,
              y: 20,
            }}
            animate={{
              opacity: 1,
              y: 0,
            }}
            className={"bg-white rounded-2xl shadow-xl p-8 max-w-md w-full text-center"}
          >
            <div
              className={
                "w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4"
              }
            >
              <TriangleAlertIcon className={"h-10 w-10 text-red-500"} />
            </div>
            <h2 className={"text-2xl font-bold text-gray-900 mb-2"}>
              {"Oops! Something went wrong"}
            </h2>
            <p className={"text-gray-600 mb-6"}>{c}</p>
            <button
              onClick={Lt}
              className={
                "bg-purple-800 hover:bg-purple-900 text-white px-6 py-3 rounded-xl font-medium transition-colors flex items-center justify-center mx-auto"
              }
            >
              <RefreshCwIcon className={"w-5 h-5 mr-2"} />
              {"Try Again"}
            </button>
          </motion.div>
        </div>
      </div>
    ) : (
      <div className={"admin-page bg-gradient-to-br from-slate-50 to-purple-100"}>
          <main className="admin-main">
          <div className={"max-w-7xl mx-auto"}>
            <motion.div initial={"hidden"} animate={"visible"} variants={On} className={"mb-8"}>
              <div className={"flex items-center justify-between"}>
                <div>
                  <h1 className={"text-3xl font-bold text-gray-900 mb-2"}>{"User Management"}</h1>
                  <p className={"text-gray-600"}>
                    {"Manage all platform users and their activities"}
                  </p>
                  {b && (
                    <div className={"flex items-center mt-2 text-sm text-purple-800"}>
                      <div
                        className={
                          "w-4 h-4 border-t-2 border-purple-800 rounded-full animate-spin mr-2"
                        }
                      />
                      {"Loading purchase statistics..."}
                    </div>
                  )}
                </div>
                <button
                  onClick={() => t("/admin/users/new")}
                  className={
                    "bg-purple-800 hover:bg-purple-900 text-white px-4 py-2 rounded-xl font-medium transition-colors flex items-center"
                  }
                >
                  <UserPlusIcon className={"w-5 h-5 mr-2"} />
                  {"Add User"}
                </button>
              </div>
            </motion.div>
            <motion.div
              initial={"hidden"}
              animate={"visible"}
              variants={ia}
              className={"grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8"}
            >
              <motion.div
                variants={On}
                className={"bg-white rounded-xl shadow-sm border border-gray-200 p-6"}
              >
                <div className={"flex items-center justify-between"}>
                  <div>
                    <p className={"text-sm font-medium text-gray-600 mb-1"}>{"Total Users"}</p>
                    <p className={"text-2xl font-bold text-gray-900"}>{Wl.toLocaleString()}</p>
                  </div>
                  <div
                    className={"w-12 h-12 bg-purple-200 rounded-lg flex items-center justify-center"}
                  >
                    <UsersIcon className={"w-6 h-6 text-purple-800"} />
                  </div>
                </div>
              </motion.div>
              <motion.div
                variants={On}
                className={"bg-white rounded-xl shadow-sm border border-gray-200 p-6"}
              >
                <div className={"flex items-center justify-between"}>
                  <div>
                    <p className={"text-sm font-medium text-gray-600 mb-1"}>{"Active Users"}</p>
                    <p className={"text-2xl font-bold text-green-600"}>{_p.toLocaleString()}</p>
                  </div>
                  <div
                    className={"w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center"}
                  >
                    <ActivityIcon className={"w-6 h-6 text-green-600"} />
                  </div>
                </div>
              </motion.div>
              <motion.div
                variants={On}
                className={"bg-white rounded-xl shadow-sm border border-gray-200 p-6"}
              >
                <div className={"flex items-center justify-between"}>
                  <div>
                    <p className={"text-sm font-medium text-gray-600 mb-1"}>
                      {"Users with Purchases"}
                    </p>
                    <p className={"text-2xl font-bold text-purple-600"}>{la.toLocaleString()}</p>
                  </div>
                  <div
                    className={
                      "w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center"
                    }
                  >
                    <ShoppingBagIcon className={"w-6 h-6 text-purple-600"} />
                  </div>
                </div>
              </motion.div>
              <motion.div
                variants={On}
                className={"bg-white rounded-xl shadow-sm border border-gray-200 p-6"}
              >
                <div className={"flex items-center justify-between"}>
                  <div>
                    <p className={"text-sm font-medium text-gray-600 mb-1"}>{"Total Revenue"}</p>
                    <p className={"text-2xl font-bold text-emerald-600"}>
                      {"₹"}
                      {ln.toLocaleString("en-IN", {
                        maximumFractionDigits: 2,
                      })}
                    </p>
                    {b && <div className={"text-xs text-gray-500 mt-1"}>{"Calculating..."}</div>}
                  </div>
                  <div
                    className={
                      "w-12 h-12 bg-emerald-100 rounded-lg flex items-center justify-center"
                    }
                  >
                    <TrendingUpIcon className={"w-6 h-6 text-emerald-600"} />
                  </div>
                </div>
              </motion.div>
            </motion.div>
            <motion.div
              initial={"hidden"}
              animate={"visible"}
              variants={On}
              className={"bg-white rounded-xl shadow-sm border border-gray-200 p-6 mb-8"}
            >
              <div className={"flex flex-col lg:flex-row gap-4"}>
                <div className={"flex-1 relative"}>
                  <SearchIcon
                    className={
                      "absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5"
                    }
                  />
                  <input
                    type={"text"}
                    placeholder={"Search by name, email, or phone..."}
                    value={f}
                    onChange={(Z) => h(Z.target.value)}
                    className={
                      "w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-700 focus:border-transparent"
                    }
                  />
                </div>
                <div className={"flex gap-3"}>
                  <select
                    value={p}
                    onChange={(Z) => g(Z.target.value)}
                    className={
                      "px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-700 focus:border-transparent"
                    }
                  >
                    <option value={"all"}>{"All Status"}</option>
                    <option value={"active"}>{"Active"}</option>
                    <option value={"block"}>{"Block"}</option>
                  </select>
                  <button
                    onClick={Lt}
                    className={
                      "px-4 py-3 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-lg transition-colors flex items-center"
                    }
                    title={"Refresh Data"}
                  >
                    <RefreshCwIcon className={"w-5 h-5"} />
                  </button>
                </div>
              </div>
              {(f || p !== "all") && (
                <div className={"mt-4 text-sm text-gray-600"}>
                  {"Showing "}
                  {Ea.length}
                  {" of "}
                  {Wl}
                  {" users"}
                  {f && ` matching "${f}"`}
                  {p !== "all" && ` with status "${p}"`}
                </div>
              )}
            </motion.div>
            <motion.div
              initial={"hidden"}
              animate={"visible"}
              variants={On}
              className={"bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden"}
            >
              {Cd.length > 0 ? (
                <jsxRuntime.Fragment>
                  <div className={"overflow-x-auto"}>
                    <table className={"min-w-full divide-y divide-gray-200"}>
                      <thead className={"bg-gray-50"}>
                        <tr>
                          <th
                            className={
                              "px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                            }
                          >
                            {"User"}
                          </th>
                          <th
                            className={
                              "px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                            }
                          >
                            {"Contact"}
                          </th>
                          <th
                            className={
                              "px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                            }
                          >
                            {"Joined"}
                          </th>
                          <th
                            className={
                              "px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                            }
                          >
                            {"Purchase Activity"}
                          </th>
                          <th
                            className={
                              "px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                            }
                          >
                            {"Status"}
                          </th>
                          <th
                            className={
                              "px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                            }
                          >
                            {"Actions"}
                          </th>
                        </tr>
                      </thead>
                      <tbody className={"bg-white divide-y divide-gray-200"}>
                        {Cd.map((Z, Le) => {
                          const Ne = bt(Z.id);
                          return (
                            <motion.tr
                              key={Z.id}
                              initial={{
                                opacity: 0,
                                y: 20,
                              }}
                              animate={{
                                opacity: 1,
                                y: 0,
                              }}
                              transition={{
                                delay: Le * 0.05,
                              }}
                              className={"hover:bg-gray-50 transition-colors"}
                            >
                              <td className={"px-6 py-4 whitespace-nowrap"}>
                                <div className={"flex items-center"}>
                                  <div
                                    className={
                                      "w-10 h-10 bg-gradient-to-r from-purple-700 to-purple-600 rounded-full flex items-center justify-center text-white font-medium text-sm"
                                    }
                                  >
                                    {Z.name ? Z.name.charAt(0).toUpperCase() : "U"}
                                  </div>
                                  <div className={"ml-4"}>
                                    <div className={"text-sm font-medium text-gray-900"}>
                                      {Z.name || "Unknown User"}
                                    </div>
                                    <div className={"text-sm text-gray-500"}>
                                      {"ID: "}
                                      {Z.id}
                                    </div>
                                  </div>
                                </div>
                              </td>
                              <td className={"px-6 py-4 whitespace-nowrap"}>
                                <div className={"text-sm text-gray-900 flex items-center mb-1"}>
                                  <MailIcon className={"w-4 h-4 mr-2 text-gray-400"} />
                                  {Z.email || "No email"}
                                </div>
                                {Z.phone && (
                                  <div className={"text-sm text-gray-500 flex items-center"}>
                                    <PhoneIcon className={"w-4 h-4 mr-2 text-gray-400"} />
                                    {Z.phone}
                                  </div>
                                )}
                              </td>
                              <td className={"px-6 py-4 whitespace-nowrap"}>
                                <div className={"flex items-center text-sm text-gray-600"}>
                                  <CalendarIcon className={"w-4 h-4 mr-2 text-gray-400"} />
                                  {Z.created_at
                                    ? new Date(Z.created_at).toLocaleDateString("en-IN")
                                    : "N/A"}
                                </div>
                              </td>
                              <td className={"px-6 py-4 whitespace-nowrap"}>
                                <div className={"space-y-1"}>
                                  <div className={"flex items-center text-sm text-gray-600"}>
                                    <ShoppingBagIcon className={"w-4 h-4 mr-2 text-gray-400"} />
                                    <span className={"font-medium text-purple-600"}>
                                      {Ne.purchaseCount}
                                    </span>
                                    <span className={"ml-1"}>{"purchases"}</span>
                                  </div>
                                  {Ne.totalAmount > 0 && (
                                    <div className={"text-sm text-gray-500 flex items-center"}>
                                      <DollarSignIcon className={"w-4 h-4 mr-2 text-gray-400"} />
                                      <span className={"font-medium text-emerald-600"}>
                                        {"₹"}
                                        {Ne.totalAmount.toLocaleString("en-IN", {
                                          maximumFractionDigits: 2,
                                        })}
                                      </span>
                                      <span className={"ml-1 text-gray-500"}>{"revenue"}</span>
                                    </div>
                                  )}
                                  {Ne.purchaseCount > 0 && (
                                    <div className={"text-xs text-gray-400"}>
                                      {"Avg: ₹"}
                                      {(Ne.totalAmount / Ne.purchaseCount).toLocaleString("en-IN", {
                                        maximumFractionDigits: 0,
                                      })}
                                    </div>
                                  )}
                                  {b && Ne.purchaseCount === 0 && (
                                    <div className={"text-xs text-purple-700 flex items-center"}>
                                      <div
                                        className={
                                          "w-3 h-3 border-t border-purple-700 rounded-full animate-spin mr-1"
                                        }
                                      />
                                      {"Loading..."}
                                    </div>
                                  )}
                                </div>
                              </td>
                              <td className={"px-6 py-4 whitespace-nowrap"}>
                                <span
                                  className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${Z.active_status === "active" || !Z.active_status ? "bg-green-100 text-green-800" : Z.active_status === "block" ? "bg-gray-100 text-gray-800" : "bg-red-100 text-red-800"}`}
                                >
                                  {Z.active_status || "active"}
                                </span>
                              </td>
                              <td
                                className={
                                  "px-6 py-4 whitespace-nowrap text-right text-sm font-medium"
                                }
                              >
                                <div className={"flex items-center justify-end space-x-2"}>
                                  <button
                                    onClick={() => Ue(Z)}
                                    className={
                                      "text-purple-800 hover:text-purple-900 p-2 rounded-lg hover:bg-purple-100 transition-colors"
                                    }
                                    title={"View Details"}
                                  >
                                    <EyeIcon className={"w-4 h-4"} />
                                  </button>
                                  <button
                                    onClick={() => ot(Z)}
                                    className={
                                      "text-green-600 hover:text-green-900 p-2 rounded-lg hover:bg-green-50 transition-colors"
                                    }
                                    title={"Edit User"}
                                  >
                                    <PenLineIcon className={"w-4 h-4"} />
                                  </button>
                                  <button
                                    onClick={() => wt(Z)}
                                    className={
                                      "text-red-600 hover:text-red-900 p-2 rounded-lg hover:bg-red-50 transition-colors"
                                    }
                                    title={"Delete User"}
                                  >
                                    <Trash2Icon className={"w-4 h-4"} />
                                  </button>
                                </div>
                              </td>
                            </motion.tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                  {Qt > 1 && (
                    <div className={"bg-gray-50 px-6 py-4 border-t border-gray-200"}>
                      <div className={"flex items-center justify-between"}>
                        <div className={"text-sm text-gray-700"}>
                          {"Showing "}
                          {oa + 1}
                          {" to "}
                          {Math.min(oa + on, Ea.length)}
                          {" of "}
                          {Ea.length}
                          {" results"}
                        </div>
                        <div className={"flex items-center space-x-2"}>
                          <button
                            onClick={Md}
                            disabled={Xe === 1}
                            className={`p-2 rounded-lg border transition-colors ${Xe === 1 ? "text-gray-400 bg-gray-100 cursor-not-allowed border-gray-200" : "text-gray-700 bg-white hover:bg-gray-50 border-gray-300 hover:border-gray-400"}`}
                            title={"Previous Page"}
                          >
                            <ChevronLeftIcon className={"w-5 h-5"} />
                          </button>
                          <div className={"flex items-center space-x-1"}>
                            {Xl().map((Z, Le) =>
                              Z === "..." ? (
                                <span key={`ellipsis-${Le}`} className={"px-3 py-2 text-gray-400"}>
                                  {"..."}
                                </span>
                              ) : (
                                <button
                                  key={Z}
                                  onClick={() => Yl(Z)}
                                  className={`px-3 py-2 rounded-lg text-sm font-medium transition-colors ${Z === Xe ? "bg-purple-800 text-white shadow-sm" : "text-gray-700 bg-white hover:bg-gray-50 border border-gray-300 hover:border-gray-400"}`}
                                >
                                  {Z}
                                </button>
                              ),
                            )}
                          </div>
                          <button
                            onClick={Pd}
                            disabled={Xe === Qt}
                            className={`p-2 rounded-lg border transition-colors ${Xe === Qt ? "text-gray-400 bg-gray-100 cursor-not-allowed border-gray-200" : "text-gray-700 bg-white hover:bg-gray-50 border-gray-300 hover:border-gray-400"}`}
                            title={"Next Page"}
                          >
                            <ChevronRightIcon className={"w-5 h-5"} />
                          </button>
                        </div>
                      </div>
                      <div className={"mt-3 text-center"}>
                        <span className={"text-sm text-gray-500"}>
                          {"Page "}
                          {Xe}
                          {" of "}
                          {Qt}
                          {" • "}
                          {Ea.length}
                          {" total users"}
                        </span>
                        {b && (
                          <span className={"text-sm text-purple-700 ml-2"}>
                            {"• Loading purchase data..."}
                          </span>
                        )}
                      </div>
                    </div>
                  )}
                </jsxRuntime.Fragment>
              ) : (
                <div className={"p-12 text-center"}>
                  <div
                    className={
                      "w-20 h-20 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4"
                    }
                  >
                    <UsersIcon className={"h-10 w-10 text-gray-400"} />
                  </div>
                  <h3 className={"text-xl font-semibold text-gray-900 mb-2"}>{"No Users Found"}</h3>
                  <p className={"text-gray-600 mb-6"}>
                    {f || p !== "all"
                      ? "Try adjusting your search or filter criteria"
                      : "No users have been registered yet"}
                  </p>
                  {(f || p !== "all") && (
                    <button
                      onClick={() => {
                        (h(""), g("all"));
                      }}
                      className={"text-purple-800 hover:text-purple-900 font-medium"}
                    >
                      {"Clear filters"}
                    </button>
                  )}
                </div>
              )}
            </motion.div>
          </div>
        </main>
        <AnimatePresence>
          {O && q && (
            <motion.div
              initial={{
                opacity: 0,
              }}
              animate={{
                opacity: 1,
              }}
              exit={{
                opacity: 0,
              }}
              className={
                "fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50"
              }
              onClick={() => _(false)}
            >
              <motion.div
                initial={{
                  opacity: 0,
                  scale: 0.95,
                }}
                animate={{
                  opacity: 1,
                  scale: 1,
                }}
                exit={{
                  opacity: 0,
                  scale: 0.95,
                }}
                className={
                  "bg-white rounded-2xl shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-hidden"
                }
                onClick={(Z) => Z.stopPropagation()}
              >
                <div
                  className={"bg-gradient-to-r from-purple-800 to-purple-600 px-6 py-4 text-white"}
                >
                  <div className={"flex justify-between items-center"}>
                    <div className={"flex items-center"}>
                      <div
                        className={
                          "w-12 h-12 bg-white/20 rounded-full flex items-center justify-center mr-4"
                        }
                      >
                        <span className={"text-lg font-bold"}>
                          {q.name ? q.name.charAt(0).toUpperCase() : "U"}
                        </span>
                      </div>
                      <div>
                        <h3 className={"text-xl font-bold"}>{q.name || "Unknown User"}</h3>
                        <p className={"text-purple-200"}>
                          {"User ID: "}
                          {q.id}
                        </p>
                      </div>
                    </div>
                    <button
                      onClick={() => _(false)}
                      className={
                        "text-white hover:text-gray-200 p-2 rounded-lg hover:bg-white/10 transition-colors"
                      }
                    >
                      <XIcon className={"w-6 h-6"} />
                    </button>
                  </div>
                </div>
                <div className={"p-6 overflow-y-auto max-h-[calc(90vh-120px)]"}>
                  <div className={"grid grid-cols-1 lg:grid-cols-2 gap-8"}>
                    <div className={"space-y-6"}>
                      <div>
                        <h4
                          className={"text-lg font-semibold text-gray-900 mb-4 flex items-center"}
                        >
                          <UsersIcon className={"w-5 h-5 mr-2 text-purple-800"} />
                          {"Personal Information"}
                        </h4>
                        <div className={"bg-gray-50 rounded-xl p-4 space-y-4"}>
                          <div className={"flex justify-between items-center"}>
                            <span className={"text-sm font-medium text-gray-600"}>
                              {"Full Name"}
                            </span>
                            <span className={"text-gray-900"}>{q.name || "Not provided"}</span>
                          </div>
                          <div className={"flex justify-between items-center"}>
                            <span className={"text-sm font-medium text-gray-600"}>{"Email"}</span>
                            <span className={"text-gray-900"}>{q.email || "Not provided"}</span>
                          </div>
                          <div className={"flex justify-between items-center"}>
                            <span className={"text-sm font-medium text-gray-600"}>{"Phone"}</span>
                            <span className={"text-gray-900"}>{q.phone || "Not provided"}</span>
                          </div>
                          <div className={"flex justify-between items-center"}>
                            <span className={"text-sm font-medium text-gray-600"}>{"Status"}</span>
                            <span
                              className={`px-2 py-1 text-xs font-semibold rounded-full ${q.active_status === "active" || !q.active_status ? "bg-green-100 text-green-800" : q.active_status === "block" ? "bg-gray-100 text-gray-800" : "bg-red-100 text-red-800"}`}
                            >
                              {q.active_status || "active"}
                            </span>
                          </div>
                          <div className={"flex justify-between items-center"}>
                            <span className={"text-sm font-medium text-gray-600"}>{"Joined"}</span>
                            <span className={"text-gray-900"}>
                              {q.created_at
                                ? new Date(q.created_at).toLocaleDateString("en-IN", {
                                    year: "numeric",
                                    month: "long",
                                    day: "numeric",
                                  })
                                : "Unknown"}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div>
                        <h4
                          className={"text-lg font-semibold text-gray-900 mb-4 flex items-center"}
                        >
                          <ActivityIcon className={"w-5 h-5 mr-2 text-purple-600"} />
                          {"Purchase Statistics"}
                        </h4>
                        <div className={"bg-gray-50 rounded-xl p-4 space-y-4"}>
                          <div className={"flex justify-between items-center"}>
                            <span className={"text-sm font-medium text-gray-600"}>
                              {"Total Purchases"}
                            </span>
                            <span className={"text-lg font-bold text-purple-600"}>
                              {bt(q.id).purchaseCount}
                            </span>
                          </div>
                          <div className={"flex justify-between items-center"}>
                            <span className={"text-sm font-medium text-gray-600"}>
                              {"Total Revenue"}
                            </span>
                            <span className={"text-lg font-bold text-emerald-600"}>
                              {"₹"}
                              {bt(q.id).totalAmount.toLocaleString("en-IN", {
                                maximumFractionDigits: 2,
                              })}
                            </span>
                          </div>
                          <div className={"flex justify-between items-center"}>
                            <span className={"text-sm font-medium text-gray-600"}>
                              {"Average Order Value"}
                            </span>
                            <span className={"text-gray-900"}>
                              {bt(q.id).purchaseCount > 0
                                ? `₹${(
                                    bt(q.id).totalAmount / bt(q.id).purchaseCount
                                  ).toLocaleString("en-IN", {
                                    maximumFractionDigits: 2,
                                  })}`
                                : "₹0"}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div>
                        <h4 className={"text-lg font-semibold text-gray-900 mb-4"}>
                          {"Quick Actions"}
                        </h4>
                        <div className={"flex flex-wrap gap-3"}>
                          <button
                            onClick={() => {
                              (_(false), ot(q));
                            }}
                            className={
                              "bg-purple-800 hover:bg-purple-900 text-white px-4 py-2 rounded-lg font-medium transition-colors flex items-center"
                            }
                          >
                            <PenLineIcon className={"w-4 h-4 mr-2"} />
                            {"Edit User"}
                          </button>
                          <button
                            onClick={() => {
                              (_(false), wt(q));
                            }}
                            className={
                              "bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-lg font-medium transition-colors flex items-center"
                            }
                          >
                            <Trash2Icon className={"w-4 h-4 mr-2"} />
                            {"Delete User"}
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className={"space-y-6"}>
                      <div>
                        <h4
                          className={"text-lg font-semibold text-gray-900 mb-4 flex items-center"}
                        >
                          <ShoppingBagIcon className={"w-5 h-5 mr-2 text-purple-600"} />
                          {"Purchase History"}
                          <span
                            className={
                              "ml-2 bg-gray-100 text-gray-800 text-xs px-2 py-1 rounded-full"
                            }
                          >
                            {re.length}
                          </span>
                        </h4>
                        {W ? (
                          <div className={"flex items-center justify-center py-12"}>
                            <div
                              className={
                                "w-8 h-8 border-t-2 border-purple-800 rounded-full animate-spin"
                              }
                            />
                          </div>
                        ) : re.length > 0 ? (
                          <div className={"space-y-3 max-h-96 overflow-y-auto"}>
                            {re.map((Z) => (
                              <div
                                key={Z.id}
                                className={
                                  "bg-white border border-gray-200 rounded-xl p-4 hover:shadow-md transition-shadow"
                                }
                              >
                                <div className={"flex justify-between items-start mb-2"}>
                                  <div className={"flex-1"}>
                                    <h5 className={"font-medium text-gray-900 mb-1"}>
                                      {Z.product_title || "Unknown Product"}
                                    </h5>
                                    <div
                                      className={
                                        "flex items-center text-sm text-gray-500 space-x-4"
                                      }
                                    >
                                      <span className={"flex items-center"}>
                                        <CalendarIcon className={"w-4 h-4 mr-1"} />
                                        {new Date(
                                          Z.purchase_date || Z.created_at,
                                        ).toLocaleDateString("en-IN")}
                                      </span>
                                      <span
                                        className={"flex items-center font-medium text-emerald-600"}
                                      >
                                        <DollarSignIcon className={"w-4 h-4 mr-1"} />
                                        {"₹"}
                                        {parseFloat(Z.amount || 0).toLocaleString("en-IN", {
                                          maximumFractionDigits: 2,
                                        })}
                                      </span>
                                    </div>
                                  </div>
                                  <div className={"flex items-center space-x-2 ml-4"}>
                                    <span
                                      className={`px-2 py-1 text-xs font-semibold rounded-full ${Z.status === "completed" || Z.status === "paid" ? "bg-green-100 text-green-800" : Z.status === "pending" ? "bg-yellow-100 text-yellow-800" : Z.status === "failed" ? "bg-red-100 text-red-800" : "bg-gray-100 text-gray-800"}`}
                                    >
                                      {Z.status || "completed"}
                                    </span>
                                    <button
                                      onClick={() => pi(Z)}
                                      className={
                                        "text-purple-800 hover:text-purple-900 p-1 rounded hover:bg-purple-100 transition-colors"
                                      }
                                      title={"Edit Purchase"}
                                    >
                                      <PenLineIcon className={"w-4 h-4"} />
                                    </button>
                                    <button
                                      onClick={() => Ta(Z)}
                                      className={
                                        "text-red-600 hover:text-red-900 p-1 rounded hover:bg-red-50 transition-colors"
                                      }
                                      title={"Delete Purchase"}
                                    >
                                      <Trash2Icon className={"w-4 h-4"} />
                                    </button>
                                  </div>
                                </div>
                                {Z.razorpay_payment_id && (
                                  <div
                                    className={
                                      "text-xs text-gray-500 bg-gray-50 rounded px-2 py-1 mt-2"
                                    }
                                  >
                                    {"Payment ID: "}
                                    {Z.razorpay_payment_id}
                                  </div>
                                )}
                              </div>
                            ))}
                          </div>
                        ) : (
                          <div className={"text-center py-12"}>
                            <div
                              className={
                                "w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4"
                              }
                            >
                              <ShoppingBagIcon className={"h-8 w-8 text-gray-400"} />
                            </div>
                            <p className={"text-gray-600 font-medium"}>{"No purchases found"}</p>
                            <p className={"text-gray-500 text-sm"}>
                              {"This user hasn't made any purchases yet"}
                            </p>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </motion.div>
            </motion.div>
          )}
          {C && Y && (
            <motion.div
              initial={{
                opacity: 0,
              }}
              animate={{
                opacity: 1,
              }}
              exit={{
                opacity: 0,
              }}
              className={
                "fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50"
              }
              onClick={() => A(false)}
            >
              <motion.div
                initial={{
                  opacity: 0,
                  scale: 0.95,
                }}
                animate={{
                  opacity: 1,
                  scale: 1,
                }}
                exit={{
                  opacity: 0,
                  scale: 0.95,
                }}
                className={"bg-white rounded-2xl shadow-2xl max-w-md w-full"}
                onClick={(Z) => Z.stopPropagation()}
              >
                <div className={"px-6 py-4 border-b border-gray-200"}>
                  <div className={"flex justify-between items-center"}>
                    <h3 className={"text-xl font-bold text-gray-900"}>{"Edit User"}</h3>
                    <button
                      onClick={() => A(false)}
                      className={
                        "text-gray-400 hover:text-gray-600 p-2 rounded-lg hover:bg-gray-100 transition-colors"
                      }
                    >
                      <XIcon className={"w-6 h-6"} />
                    </button>
                  </div>
                </div>
                <form onSubmit={rt} className={"p-6 space-y-4"}>
                  <div>
                    <label className={"block text-sm font-medium text-gray-700 mb-2"}>
                      {"Full Name "}
                      <span className={"text-red-500"}>{"*"}</span>
                    </label>
                    <input
                      type={"text"}
                      value={ye.name}
                      onChange={(Z) =>
                        V({
                          ...ye,
                          name: Z.target.value,
                        })
                      }
                      className={
                        "w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-700 focus:border-transparent"
                      }
                      placeholder={"Enter full name"}
                      required={true}
                      maxLength={"100"}
                    />
                  </div>
                  <div>
                    <label className={"block text-sm font-medium text-gray-700 mb-2"}>
                      {"Email Address "}
                      <span className={"text-red-500"}>{"*"}</span>
                    </label>
                    <input
                      type={"email"}
                      value={ye.email}
                      onChange={(Z) =>
                        V({
                          ...ye,
                          email: Z.target.value,
                        })
                      }
                      className={
                        "w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-700 focus:border-transparent"
                      }
                      placeholder={"Enter email address"}
                      required={true}
                      maxLength={"255"}
                    />
                  </div>
                  <div />
                  <label className={"block text-sm font-medium text-gray-700 mb-2"}>
                    {"Phone Number"}
                  </label>
                  <input
                    type={"tel"}
                    value={ye.phone}
                    onChange={(Z) => {
                      const Le = Z.target.value.replace(/\D/g, "");
                      V({
                        ...ye,
                        phone: Le,
                      });
                    }}
                    className={
                      "w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-700 focus:border-transparent"
                    }
                    placeholder={"Enter phone number"}
                    maxLength={"15"}
                  />
                  <p className={"text-xs text-gray-500 mt-1"}>
                    {"Enter digits only (minimum 10 digits)"}
                  </p>
                  <div>
                    <label className={"block text-sm font-medium text-gray-700 mb-2"}>
                      {"Account Status"}
                    </label>
                    <select
                      value={ye.active_status}
                      onChange={(Z) =>
                        V({
                          ...ye,
                          active_status: Z.target.value,
                        })
                      }
                      className={
                        "w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-700 focus:border-transparent"
                      }
                    >
                      <option value={"active"}>{"Active"}</option>
                      <option value={"block"}>{"Block"}</option>
                    </select>
                  </div>
                  <div className={"flex justify-end space-x-3 pt-6"}>
                    <button
                      type={"button"}
                      onClick={() => A(false)}
                      className={
                        "px-6 py-3 text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors font-medium"
                      }
                      disabled={ce}
                    >
                      {"Cancel"}
                    </button>
                    <button
                      type={"submit"}
                      disabled={ce}
                      className={
                        "px-6 py-3 bg-purple-800 text-white rounded-lg hover:bg-purple-900 transition-colors flex items-center font-medium disabled:opacity-50 disabled:cursor-not-allowed"
                      }
                    >
                      {ce ? (
                        <jsxRuntime.Fragment>
                          <div
                            className={
                              "w-4 h-4 border-t-2 border-white rounded-full animate-spin mr-2"
                            }
                          />
                          {"Saving..."}
                        </jsxRuntime.Fragment>
                      ) : (
                        <jsxRuntime.Fragment>
                          <SaveIcon className={"w-4 h-4 mr-2"} />
                          {"Save Changes"}
                        </jsxRuntime.Fragment>
                      )}
                    </button>
                  </div>
                </form>
              </motion.div>
            </motion.div>
          )}
          {k && Q && (
            <motion.div
              initial={{
                opacity: 0,
              }}
              animate={{
                opacity: 1,
              }}
              exit={{
                opacity: 0,
              }}
              className={
                "fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50"
              }
              onClick={() => $(false)}
            >
              <motion.div
                initial={{
                  opacity: 0,
                  scale: 0.95,
                }}
                animate={{
                  opacity: 1,
                  scale: 1,
                }}
                exit={{
                  opacity: 0,
                  scale: 0.95,
                }}
                className={
                  "bg-white rounded-2xl shadow-2xl max-w-lg w-full max-h-[90vh] overflow-hidden"
                }
                onClick={(Z) => Z.stopPropagation()}
              >
                <div className={"px-6 py-4 border-b border-gray-200"}>
                  <div className={"flex justify-between items-center"}>
                    <h3 className={"text-xl font-bold text-gray-900"}>{"Edit Purchase"}</h3>
                    <button
                      onClick={() => $(false)}
                      className={
                        "text-gray-400 hover:text-gray-600 p-2 rounded-lg hover:bg-gray-100 transition-colors"
                      }
                    >
                      <XIcon className={"w-6 h-6"} />
                    </button>
                  </div>
                </div>
                <div className={"overflow-y-auto max-h-[calc(90vh-120px)]"}>
                  <form onSubmit={sa} className={"p-6 space-y-4"}>
                    <div>
                      <label className={"block text-sm font-medium text-gray-700 mb-2"}>
                        {"Purchase ID"}
                      </label>
                      <input
                        type={"text"}
                        value={de.id}
                        className={"w-full px-4 py-3 border border-gray-300 rounded-lg bg-gray-50"}
                        placeholder={"Purchase ID"}
                        readOnly={true}
                      />
                    </div>
                    <div>
                      <label className={"block text-sm font-medium text-gray-700 mb-2"}>
                        {"Product ID "}
                        <span className={"text-red-500"}>{"*"}</span>
                      </label>
                      <div className={"relative"}>
                        <input
                          type={"number"}
                          value={de.product_id}
                          onChange={(Z) =>
                            oe({
                              ...de,
                              product_id: Z.target.value,
                            })
                          }
                          className={
                            "w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-700 focus:border-transparent pr-10"
                          }
                          placeholder={"Enter product ID"}
                          required={true}
                          min={"1"}
                        />
                        {ve && (
                          <div
                            className={
                              "absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
                            }
                          >
                            <div
                              className={
                                "w-4 h-4 border-t-2 border-purple-800 rounded-full animate-spin"
                              }
                            />
                          </div>
                        )}
                      </div>
                      <p className={"text-xs text-gray-500 mt-1"}>
                        {"Product title will auto-update when you change the ID"}
                      </p>
                    </div>
                    <div>
                      <label className={"block text-sm font-medium text-gray-700 mb-2"}>
                        {"Product Title "}
                        <span className={"text-red-500"}>{"*"}</span>
                      </label>
                      <div className={"relative"}>
                        <input
                          type={"text"}
                          value={de.product_title}
                          onChange={(Z) =>
                            oe({
                              ...de,
                              product_title: Z.target.value,
                            })
                          }
                          className={`w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-700 focus:border-transparent ${ve ? "bg-gray-50" : ""}`}
                          placeholder={"Enter product title"}
                          required={true}
                          maxLength={"255"}
                          disabled={ve}
                        />
                        {ve && (
                          <div
                            className={
                              "absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
                            }
                          >
                            <div
                              className={
                                "w-4 h-4 border-t-2 border-purple-800 rounded-full animate-spin"
                              }
                            />
                          </div>
                        )}
                      </div>
                      <p className={"text-xs text-gray-500 mt-1"}>
                        {ve
                          ? "Fetching product details..."
                          : "You can manually edit this if needed"}
                      </p>
                    </div>
                    <div>
                      <label className={"block text-sm font-medium text-gray-700 mb-2"}>
                        {"Amount "}
                        <span className={"text-red-500"}>{"*"}</span>
                      </label>
                      <div className={"relative"}>
                        <div
                          className={
                            "absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
                          }
                        >
                          <DollarSignIcon className={"h-5 w-5 text-gray-400"} />
                        </div>
                        <input
                          type={"number"}
                          step={"0.01"}
                          min={"0"}
                          value={de.amount}
                          onChange={(Z) =>
                            oe({
                              ...de,
                              amount: Z.target.value,
                            })
                          }
                          className={
                            "w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-700 focus:border-transparent"
                          }
                          placeholder={"Enter amount"}
                          required={true}
                        />
                      </div>
                      <p className={"text-xs text-gray-500 mt-1"}>
                        {"Enter the purchase amount in rupees"}
                      </p>
                    </div>
                    <div>
                      <label className={"block text-sm font-medium text-gray-700 mb-2"}>
                        {"Status"}
                      </label>
                      <select
                        value={de.status}
                        onChange={(Z) =>
                          oe({
                            ...de,
                            status: Z.target.value,
                          })
                        }
                        className={
                          "w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-700 focus:border-transparent"
                        }
                      >
                        <option value={"completed"}>{"Completed"}</option>
                        <option value={"paid"}>{"Paid"}</option>
                        <option value={"pending"}>{"Pending"}</option>
                        <option value={"failed"}>{"Failed"}</option>
                      </select>
                    </div>
                    <div>
                      <label className={"block text-sm font-medium text-gray-700 mb-2"}>
                        {"Razorpay Order ID"}
                      </label>
                      <input
                        type={"text"}
                        value={de.razorpay_order_id}
                        onChange={(Z) =>
                          oe({
                            ...de,
                            razorpay_order_id: Z.target.value,
                          })
                        }
                        className={
                          "w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-700 focus:border-transparent"
                        }
                        placeholder={"Enter Razorpay order ID (optional)"}
                        maxLength={"100"}
                      />
                    </div>
                    <div>
                      <label className={"block text-sm font-medium text-gray-700 mb-2"}>
                        {"Razorpay Payment ID"}
                      </label>
                      <input
                        type={"text"}
                        value={de.razorpay_payment_id}
                        onChange={(Z) =>
                          oe({
                            ...de,
                            razorpay_payment_id: Z.target.value,
                          })
                        }
                        className={
                          "w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-700 focus:border-transparent"
                        }
                        placeholder={"Enter Razorpay payment ID (optional)"}
                        maxLength={"100"}
                      />
                    </div>
                    <div>
                      <label className={"block text-sm font-medium text-gray-700 mb-2"}>
                        {"Purchase Date"}
                      </label>
                      <input
                        type={"date"}
                        value={de.purchase_date}
                        onChange={(Z) =>
                          oe({
                            ...de,
                            purchase_date: Z.target.value,
                          })
                        }
                        className={
                          "w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-700 focus:border-transparent"
                        }
                      />
                    </div>
                    <div className={"flex justify-end space-x-3 pt-6"}>
                      <button
                        type={"button"}
                        onClick={() => $(false)}
                        className={
                          "px-6 py-3 text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors font-medium"
                        }
                        disabled={Ae}
                      >
                        {"Cancel"}
                      </button>
                      <button
                        type={"submit"}
                        disabled={Ae}
                        className={
                          "px-6 py-3 bg-purple-800 text-white rounded-lg hover:bg-purple-900 transition-colors flex items-center font-medium disabled:opacity-50 disabled:cursor-not-allowed"
                        }
                      >
                        {Ae ? (
                          <jsxRuntime.Fragment>
                            <div
                              className={
                                "w-4 h-4 border-t-2 border-white rounded-full animate-spin mr-2"
                              }
                            />
                            {"Saving..."}
                          </jsxRuntime.Fragment>
                        ) : (
                          <jsxRuntime.Fragment>
                            <SaveIcon className={"w-4 h-4 mr-2"} />
                            {"Save Changes"}
                          </jsxRuntime.Fragment>
                        )}
                      </button>
                    </div>
                  </form>
                </div>
              </motion.div>
            </motion.div>
          )}
          {T && B && (
            <motion.div
              initial={{
                opacity: 0,
              }}
              animate={{
                opacity: 1,
              }}
              exit={{
                opacity: 0,
              }}
              className={
                "fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50"
              }
              onClick={() => M(false)}
            >
              <motion.div
                initial={{
                  opacity: 0,
                  scale: 0.95,
                }}
                animate={{
                  opacity: 1,
                  scale: 1,
                }}
                exit={{
                  opacity: 0,
                  scale: 0.95,
                }}
                className={"bg-white rounded-2xl shadow-2xl max-w-md w-full"}
                onClick={(Z) => Z.stopPropagation()}
              >
                <div className={"p-6"}>
                  <div className={"flex items-center mb-6"}>
                    <div
                      className={
                        "w-12 h-12 bg-red-100 rounded-full flex items-center justify-center mr-4"
                      }
                    >
                      <TriangleAlertIcon className={"w-6 h-6 text-red-600"} />
                    </div>
                    <div>
                      <h3 className={"text-lg font-semibold text-gray-900"}>{"Delete User"}</h3>
                      <p className={"text-sm text-gray-500"}>{"This action cannot be undone"}</p>
                    </div>
                  </div>
                  <div className={"mb-6"}>
                    <p className={"text-gray-700 mb-2"}>
                      {"Are you sure you want to delete "}
                      <strong>{B.name || "this user"}</strong>
                      {"?"}
                    </p>
                    <div className={"bg-gray-50 rounded-lg p-3 mt-3"}>
                      <div className={"text-sm text-gray-600 space-y-1"}>
                        <div className={"flex justify-between"}>
                          <span>{"User ID:"}</span>
                          <span className={"font-medium"}>{B.id}</span>
                        </div>
                        <div className={"flex justify-between"}>
                          <span>{"Email:"}</span>
                          <span className={"font-medium"}>{B.email}</span>
                        </div>
                        <div className={"flex justify-between"}>
                          <span>{"Purchases:"}</span>
                          <span className={"font-medium"}>{bt(B.id).purchaseCount}</span>
                        </div>
                        <div className={"flex justify-between"}>
                          <span>{"Revenue:"}</span>
                          <span className={"font-medium"}>
                            {"₹"}
                            {bt(B.id).totalAmount.toLocaleString("en-IN", {
                              maximumFractionDigits: 2,
                            })}
                          </span>
                        </div>
                      </div>
                    </div>
                    <p className={"text-sm text-gray-600 mt-3"}>
                      {
                        "This will permanently remove their account and all associated data including purchase history."
                      }
                    </p>
                  </div>
                  <div className={"flex justify-end space-x-3"}>
                    <button
                      onClick={() => M(false)}
                      className={
                        "px-6 py-3 text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors font-medium"
                      }
                      disabled={Ve}
                    >
                      {"Cancel"}
                    </button>
                    <button
                      onClick={Zt}
                      disabled={Ve}
                      className={
                        "px-6 py-3 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors font-medium flex items-center disabled:opacity-50 disabled:cursor-not-allowed"
                      }
                    >
                      {Ve ? (
                        <jsxRuntime.Fragment>
                          <div
                            className={
                              "w-4 h-4 border-t-2 border-white rounded-full animate-spin mr-2"
                            }
                          />
                          {"Deleting..."}
                        </jsxRuntime.Fragment>
                      ) : (
                        <jsxRuntime.Fragment>
                          <Trash2Icon className={"w-4 h-4 mr-2"} />
                          {"Delete User"}
                        </jsxRuntime.Fragment>
                      )}
                    </button>
                  </div>
                </div>
              </motion.div>
            </motion.div>
          )}
          {I && L && (
            <motion.div
              initial={{
                opacity: 0,
              }}
              animate={{
                opacity: 1,
              }}
              exit={{
                opacity: 0,
              }}
              className={
                "fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50"
              }
              onClick={() => U(false)}
            >
              <motion.div
                initial={{
                  opacity: 0,
                  scale: 0.95,
                }}
                animate={{
                  opacity: 1,
                  scale: 1,
                }}
                exit={{
                  opacity: 0,
                  scale: 0.95,
                }}
                className={"bg-white rounded-2xl shadow-2xl max-w-md w-full"}
                onClick={(Z) => Z.stopPropagation()}
              >
                <div className={"p-6"}>
                  <div className={"flex items-center mb-6"}>
                    <div
                      className={
                        "w-12 h-12 bg-red-100 rounded-full flex items-center justify-center mr-4"
                      }
                    >
                      <TriangleAlertIcon className={"w-6 h-6 text-red-600"} />
                    </div>
                    <div>
                      <h3 className={"text-lg font-semibold text-gray-900"}>{"Delete Purchase"}</h3>
                      <p className={"text-sm text-gray-500"}>{"This action cannot be undone"}</p>
                    </div>
                  </div>
                  <div className={"mb-6"}>
                    <p className={"text-gray-700 mb-2"}>
                      {"Are you sure you want to delete the purchase for "}
                      <strong>{L.product_title}</strong>
                      {"?"}
                    </p>
                    <div className={"bg-gray-50 rounded-lg p-3 mt-3"}>
                      <div className={"text-sm text-gray-600 space-y-1"}>
                        <div className={"flex justify-between"}>
                          <span>{"Product:"}</span>
                          <span className={"font-medium"}>{L.product_title}</span>
                        </div>
                        <div className={"flex justify-between"}>
                          <span>{"Amount:"}</span>
                          <span className={"font-medium"}>
                            {"₹"}
                            {parseFloat(L.amount || 0).toLocaleString("en-IN", {
                              maximumFractionDigits: 2,
                            })}
                          </span>
                        </div>
                        <div className={"flex justify-between"}>
                          <span>{"Status:"}</span>
                          <span className={"font-medium"}>{L.status || "completed"}</span>
                        </div>
                        <div className={"flex justify-between"}>
                          <span>{"Date:"}</span>
                          <span className={"font-medium"}>
                            {new Date(L.purchase_date || L.created_at).toLocaleDateString("en-IN")}
                          </span>
                        </div>
                      </div>
                    </div>
                    <p className={"text-sm text-gray-600 mt-3"}>
                      {
                        "This will permanently remove this transaction record and affect the user's total revenue calculation."
                      }
                    </p>
                  </div>
                  <div className={"flex justify-end space-x-3"}>
                    <button
                      onClick={() => U(false)}
                      className={
                        "px-6 py-3 text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors font-medium"
                      }
                      disabled={_n}
                    >
                      {"Cancel"}
                    </button>
                    <button
                      onClick={ts}
                      disabled={_n}
                      className={
                        "px-6 py-3 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors font-medium flex items-center disabled:opacity-50 disabled:cursor-not-allowed"
                      }
                    >
                      {_n ? (
                        <jsxRuntime.Fragment>
                          <div
                            className={
                              "w-4 h-4 border-t-2 border-white rounded-full animate-spin mr-2"
                            }
                          />
                          {"Deleting..."}
                        </jsxRuntime.Fragment>
                      ) : (
                        <jsxRuntime.Fragment>
                          <Trash2Icon className={"w-4 h-4 mr-2"} />
                          {"Delete Purchase"}
                        </jsxRuntime.Fragment>
                      )}
                    </button>
                  </div>
                </div>
              </motion.div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    )
  );
};
export { UsersPage };
